import "../sass/style.scss";

import { Workbox } from "workbox-window";
import _ from "lodash";

import WCSelect2 from "./web_components/select2";
import WCFilter from "./web_components/filter";
import WCCalcLiq from "./web_components/calcliq";
import WCUpdInput from "./web_components/updinput";

if (navigator.serviceWorker) {
  var alertInstallPwa, buttonInstallPwa, deferredPrompt;

  window.addEventListener("load", function () {
    // navigator.serviceWorker.register("/service-worker.js");
    const wb = new Workbox("/service-worker.js");
    wb.addEventListener("installed", (event) => {
      if (event.isUpdate) {
        if (
          confirm(
            `Nuevo contenido es disponible! Click en OK para refrescar la app.`
          )
        ) {
          window.location.reload();
        }
      }
    });
    wb.register();

    alertInstallPwa = document.getElementById("alertInstallPwa");
    buttonInstallPwa = document.getElementById("btnInstallPwa");

    buttonInstallPwa.addEventListener("click", function (e) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then(function (choiceResult) {
        if (choiceResult.outcome === "accepted") {
          console.log("User accepted the A2HS prompt");
        }

        deferredPrompt = null;
      });
    });

    window.addEventListener("beforeinstallprompt", function (e) {
      e.preventDefault();
      deferredPrompt = e;
      alertInstallPwa.style.display = "block";
    });

    window.addEventListener("appinstalled", function (e) {
      console.log("a2hs", "installed");
      alertInstallPwa.style.display = "none";
    });
  });
}

$(function () {
  const delivery = $("*[data-cm-filter]").each(function (i, el) {
    let params = _.toPlainObject($(this).data("cm-filter"));
    console.log();
    return new WCFilter(el, params);
  });

  const select2 = $("*[data-cm-select2]").each(function (i, el) {
    let params = _.toPlainObject($(this).data("cm-select2"));
    return new WCSelect2(el, params);
  });

  const calcLiq = $("*[data-cm-calcliq]").each(function (i, el) {
    let params = _.toPlainObject($(this).data("cm-calcliq"));
    return new WCCalcLiq(el, params);
  });

  const updinput = $("*[data-cm-updinput]").each(function (i, el) {
    let params = _.toPlainObject($(this).data("cm-updinput"));
    return new WCUpdInput(el, params);
  });
});
